import { useState } from "react";
import { MenuItemConfig } from "../components/plus-button";

interface UsePlusButtonMenuItemsParams {
  autoLeadId: string | null;
  isEmailConversation: boolean;
  showMediaItem: boolean;
}

interface UsePlusButtonMenuItemsResult {
  menuItems: MenuItemConfig[];
  isTemplateSelectorOpen: boolean;
  setIsTemplateSelectorOpen: (open: boolean) => void;
  isVehicleSelectorOpen: boolean;
  setIsVehicleSelectorOpen: (open: boolean) => void;
  isMediaLibraryOpen: boolean;
  setIsMediaLibraryOpen: (open: boolean) => void;
}

export function usePlusButtonMenuItems({
  autoLeadId,
  isEmailConversation,
  showMediaItem
}: UsePlusButtonMenuItemsParams): UsePlusButtonMenuItemsResult {
  const [isTemplateSelectorOpen, setIsTemplateSelectorOpen] = useState(false);
  const [isVehicleSelectorOpen, setIsVehicleSelectorOpen] = useState(false);
  const [isMediaLibraryOpen, setIsMediaLibraryOpen] = useState(false);

  const menuItems: MenuItemConfig[] = [
    {
      id: "templates",
      label: "Templates",
      onClick: () => setIsTemplateSelectorOpen(true),
      testId: "templates-option"
    },
    {
      id: "vehicle",
      label: "Vehicle",
      onClick: () => setIsVehicleSelectorOpen(true),
      testId: "vehicle-option",
      hidden: !isEmailConversation || !autoLeadId
    },
    {
      id: "media",
      label: "Media",
      onClick: () => setIsMediaLibraryOpen(true),
      testId: "media-library-option",
      hidden: !showMediaItem
    }
  ];

  return {
    menuItems,
    isTemplateSelectorOpen,
    setIsTemplateSelectorOpen,
    isVehicleSelectorOpen,
    setIsVehicleSelectorOpen,
    isMediaLibraryOpen,
    setIsMediaLibraryOpen
  };
}
